module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-box"
  }, [_c('div', {
    staticClass: "user-tasks__header"
  }, [_c('div', [(_vm.isShowScheduled) ? _c('label', {
    staticClass: "d-label no-print"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm.dates) + " (" + _vm._s(_vm.numberOfWorkDaysInPeriod) + "\n        " + _vm._s(_vm.i18n['work_days']) + ")\n      ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "only-print"
  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.dates))])]), _vm._v(" "), (_vm.isShowHeader) ? _c('div', {
    staticClass: "d-input-group no-print no-mobile"
  }, [_c('label', {
    staticClass: "d-label",
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.show_scheduled_hours')) + " ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsShowScheduled(!_vm.isShowScheduled)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "propOn": _vm.isShowScheduled
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
    return (idx < _vm.userNorm.length - 1) ? _c('tr', {
      key: item.title
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
    return (idx === _vm.userNorm.length - 1) ? _c('tr', {
      key: item.title
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('UserTasksOverviewKindergarten', {
    attrs: {
      "isShowScheduled": _vm.isShowScheduled,
      "isDateIntervalChanged": _vm.isDateIntervalChanged,
      "assignedTotalHoursForYear": _vm.getUserHoursOverview.assigned_total_hours,
      "assignedTotalHoursForPeriod": _vm.assignedTotalHoursForPeriod,
      "diffTotalHoursForPeriod": _vm.diffTotalHoursForPeriod,
      "userActualHours": _vm.userActualHours,
      "getUserHoursOverview": _vm.getUserHoursOverview,
      "tooltipContent": _vm.tooltipContent,
      "numberOfWorkDays": _vm.numberOfWorkDays,
      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.distribution')))])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.getIsCategoryVisible('work_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v("100%")]) : _vm._e()]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.schoolTooltipContent
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
  }, [_vm._v("\n        " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('teaching')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.teaching')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTeaching))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_teaching_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_teaching_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_teaching_hours))
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_teaching_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('tasks')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.tasks')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTasks))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_additional_task_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_additional_task_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_additional_task_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('preparation')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.preparation')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPrep))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_preparation_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_preparation_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_preparation_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_pool_hours > 0 && _vm.getIsCategoryVisible('pool')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.pool')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_pool_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_pool_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.substitute_pool_hours > 0 && _vm.getIsCategoryVisible('substitute_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfSubPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.substitute_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_substitute_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_substitute_hours))
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_substitute_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_club_hours > 0 && _vm.getIsCategoryVisible('club')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfClub))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_club_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_club_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_club_hours))
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_club_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSchoolGlHjortespring && _vm.getIsCategoryVisible('teaching_and_club')) ? _c('tr', [_c('td', [_vm._v("Undervisning + SFO")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours)))
  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.assigned_club_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isShowSubsAndTeachingActive && _vm.getIsCategoryVisible('teaching_and_sub')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.titleForTeachingAndSubstituteHoursTotal))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)))
  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolWantSum && _vm.getUserAssignedTotalHours > 0 && _vm.getTotalAssigned > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.rest')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfRest))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getTotalAssigned)))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getTotalTooMany > 0 && !_vm.isSchoolWantSum && _vm.getUserAssignedTotalHours > 0) ? _c('tr', [_c('td', [_c('span', {
    staticClass: "d-bagde d-badge--warning"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.diff_from_total_workhours')))])]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTooMany))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getTotalTooMany)))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isSchoolWantSum) ? _c('tfoot', [_c('tr', [_c('td', [_vm._v("Sum")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away'
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away'\n      }"
    }],
    staticClass: "is-number cursor-help",
    attrs: {
      "content": "Sum = (Skemalagt UV + Skemalagt SFO + Tildelte Øvrige Opgaver, Tildel Forberedelse osv.) - Total tildelt arbejdstid"
    }
  }, [(_vm.getSum > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getSum)) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
    attrs: {
      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
      "isShowScheduled": _vm.isShowScheduled,
      "isDateIntervalChanged": _vm.isDateIntervalChanged,
      "userTasks": _vm.userTasksFiltered
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.userTasksFiltered), function(tasks) {
    return _c('div', {
      staticClass: "marg-1-bottom"
    }, [(tasks.title === 'substitute_hours') ? _c('UserTasksTableSubstituteHours', {
      attrs: {
        "title": tasks.title,
        "tasks": tasks.tasks,
        "userCalendarId": _vm.user.user_calendar_id,
        "userId": _vm.user.id,
        "assignedHours": _vm.getUserAssignedTeachingHours,
        "isShowScheduled": _vm.isShowScheduled
      }
    }) : _c('UserTasksTable', {
      attrs: {
        "title": tasks.title,
        "tasks": tasks.tasks,
        "userCalendarId": _vm.user.user_calendar_id,
        "userId": _vm.user.id,
        "assignedHours": _vm.getUserAssignedTeachingHours,
        "isShowScheduled": _vm.isShowScheduled
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "active-user__agreements"
  }, [_c('SubjectsDistributionUserAgreements', {
    attrs: {
      "isReadAgreements": false,
      "userAgreements": _vm.userAgreements,
      "userId": _vm.activeUserId
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.theActiveSubject) ? _c('DModal', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        _vm.theActiveSubject = null
      }
    }
  }, [_c('SubjectsDistributionUserEditHours', {
    attrs: {
      "slot": "insertComponent",
      "subject": _vm.getTheActiveSubject,
      "teacher": _vm.getTheActiveUser
    },
    on: {
      "close": function($event) {
        _vm.theActiveSubject = null
      }
    },
    slot: "insertComponent"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        _vm.theActiveSubject = null
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74a3044f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksOverview.vue
// module id = 1724
// module chunks = 1